import * as appConfig from './../../../../../app.config';

import { Component, OnInit, OnDestroy, Input, forwardRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import { File } from './../../../../../models/files/files.model';

import { FilesService } from './../../../../../shared/services/files.service';
import { EntityService } from './../../../../../shared/services/entity.service';
import { Guid } from './../../../../../shared/utils/guid';

import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ContainedComponent),
  multi: true
};

@Component({
  selector: 'swb-contained',
  templateUrl: './contained.component.html',
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class ContainedComponent extends FormEditorBase implements OnInit, OnDestroy {

  private _onModelChanged: Function;
  private _subscription: Subscription;
  private _guid: string;

  public value: any;

  constructor(
    private _filesService: FilesService,
    private _entitiesService: EntityService
  ) {
    super();
    this._guid = Guid.newGuid();
  }

  public ngOnInit(): void {
    this.handleChosenFiles();
    this.handleChosenEntities();
  }

  public registerOnChange(fn: Function): void {
    this._onModelChanged = fn;
  }

  public registerOnTouched(fn: Function): void {
    // noop
  }

  public writeValue(value: any) {
    this.value = value;
  }

  public getFileStyle(file: File): any {
    if (!file || !file.file_fullname) { return; }

    if (file.is_image) {
      if (file.is_resizable) {
        return {
          'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + '460x460_' + file.file_fullname + ')'
        };
      }
      return {
        'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + file.file_fullname + ')'
      };
    }

    return {};
  }

  public remove(i: number) {
    this.value = null;
    this.field.entity = null;
    this._onModelChanged(this.value);
  }

  public browse(): void {
    const browseConfig = { guid: this._guid, multiple: false, imgOnly: this.field.imgOnly, open: true };
    this._filesService.toggleBrowser(browseConfig);
  }

  public ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  private handleChosenFiles(): void {
    this._subscription = this._filesService.filesChosen$.subscribe((fileResponse: { files: File[], guid: string }) => {
      if (fileResponse.guid === this._guid) {
        fileResponse.files.forEach((entity, index) => {
          this.value = fileResponse.files[0].id;
          this.field.entity = fileResponse.files[0];
          this._onModelChanged(this.value);
        });
      }
    });
  }

  private handleChosenEntities(): void {
    this._entitiesService.entitiesChosen$.subscribe((entityResponse: { entities: any[], apiUrl: string }) => {
      if (entityResponse.apiUrl === this.field.apiUrl) {
        this.value = entityResponse.entities[0].id;
        this.field.entity = entityResponse.entities[0];
        this._onModelChanged(this.value);
      }
    });
  }

  public uploaded($event) {
    if ($event[1] && $event[1].file) {
      const file = $event[1].file;

      const uploadedFile = new File({
        id: file.id,
        file_fullname: file.file_fullname,
        file_name: file.file_name,
        file_type: file.file_type,
        file_size: file.file_size,
        extension: file.extension,
        is_image: file.is_image,
        is_resizable: file.is_resizable,
        // description: file.description,
        _joinData: {
          'id': file.id,
          'entityorder': 999
        }
      });

      // update the model so we can see the new file
      this.value = uploadedFile.id;
      this.field.entity = uploadedFile;
      this._onModelChanged(this.value);
    }
  }

}
